import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';

export const faqItems = [
  {
    q: '瓜田追踪和普通的爆料号有什么不同？',
    a: '我们不抢首发，也不以“放料”为目的。每条内容都会附带时间线、状态标签和来源说明，重点是把事件从发生到回应的过程讲清楚，而不是只截取最刺激的那一段。',
  },
  {
    q: '事件反转后，之前的记录会怎么处理？',
    a: '我们会保留原节点并标注它已被后续信息修正，而不是悄悄删掉。读者因此能看到“当时是这样说的，后来发生了什么变化”，这也是反转档案存在的意义。',
  },
  {
    q: '你们怎样判断一条爆料是否可信？',
    a: '优先级依次是：官方通报与平台处理结果、当事人实名回应、可核验的书面材料（合同、单据、完整视频），最后才是匿名爆料。缺少佐证的说法会被标记为待核实，而不是直接采用。',
  },
  {
    q: '“待核实”和“已澄清”分别代表什么？',
    a: '“待核实”表示现有证据不足以支持或否定该说法，我们会持续关注并欢迎补充材料；“已澄清”表示经过第三方或权威信息交叉比对后，原有的质疑已被合理说明。',
  },
  {
    q: '如果我的账号被卷进爆料，想回应或要求更正怎么办？',
    a: '可以通过页面下方的邮箱或订阅表单联系我们，附上公开可查的说明链接。经核实后我们会更新对应条目，并在时间线中记录这次更正。',
  },
  {
    q: '网站上的内容可以作为结论引用吗？',
    a: '不建议。我们的定位是帮助读者了解进展脉络，最终事实应以官方通报和当事人正式声明为准。涉及法律争议的部分，请以生效法律文书为最终依据。',
  },
];

const FaqSection = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 border-b border-background-200 bg-background-100">
      <div className="layout-shell grid grid-cols-1 gap-10 py-12 md:py-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="FAQ"
            title="常见问题"
            desc="关于我们如何追踪、如何核实、如何处理更正，这里是最常被问到的几个问题。"
          />
          <div className="mt-6 rounded-lg border border-background-300/70 bg-background-50 p-5">
            <div className="flex items-center gap-2 text-secondary-700">
              <i className="ri-lightbulb-line" aria-hidden="true" />
              <span className="text-sm font-medium">理性吃瓜提示</span>
            </div>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              看到一条爆料时，先问三件事：谁说的、有没有原始材料、有没有人对质。想清楚这三点，大多数传闻会自己现出原形。
            </p>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ul className="overflow-hidden rounded-lg border border-background-300/70 bg-background-50">
            {faqItems.map((item, index) => {
              const isOpen = open === index;
              return (
                <li key={item.q} className="border-b border-background-200 last:border-b-0">
                  <h3>
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpen(isOpen ? null : index)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                    >
                      <span className="font-heading text-[15px] font-bold text-foreground-950">{item.q}</span>
                      <span className="flex h-7 w-7 flex-none items-center justify-center rounded-md border border-background-300 text-foreground-700">
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true" />
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <div className="px-5 pb-5">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;